import ownBgPc from './assets/own-bg-pc.png'
import ownBgMobile from './assets/own-bg-mobile.png'

function App() {
  return (
    <main className='landing landing-page'>
      <div className='content-container'>
        <div className='bg-wrap'>
          <img
            src={ownBgPc}
            className='bg-image bg-image-pc'
            alt='Background'
          />
          <img
            src={ownBgMobile}
            className='bg-image bg-image-mobile'
            alt='Background'
          />
          <div className='bg-overlay' />
        </div>
        <div className='inner-wrap'>
          <h1>
            <span className='sr-only'>OWN CLINIC</span>
          </h1>
          <div className='content-gradient'>
            <section className='landing-sites container'>
              <dl className='province'>
                <dt>
                  SEOUL <em>서 울</em>
                </dt>
                <dd>
                  <ul>
                    <li>
                      <a
                        target='_blank'
                        href='https://samseong.own-clinic.com/'
                        alt='오운 클리닉 삼성점'
                        rel='noreferrer'
                      >
                        삼성점
                      </a>
                    </li>
                  </ul>
                </dd>
              </dl>
              <dl className='province'>
                <dt>
                  GYEONGGI <em>경 기</em>
                </dt>
                <dd>
                  <ul>
                    <li>
                      <a
                        target='_blank'
                        href='https://guri.own-clinic.com/'
                        alt='오운 클리닉 구리점'
                        rel='noreferrer'
                      >
                        구리점
                      </a>
                    </li>
                  </ul>
                </dd>
              </dl>
              <dl className='province'>
                <dt>
                  INCHEON <em>인 천</em>
                </dt>
                <dd>
                  <ul>
                    <li>
                      <a
                        target='_blank'
                        href='https://songdo.own-clinic.com/'
                        alt='오운 클리닉 송도점'
                        rel='noreferrer'
                      >
                        송도점
                      </a>
                    </li>
                  </ul>
                </dd>
              </dl>
            </section>
          </div>
        </div>
      </div>
      <div className='footer-container'>
        <footer className='container'>
          <ul className='affiliates list-unstyled'>
            <li>
              <span className='name'>삼성점</span>
              <span className='tel'>
                TEL: <a href='tel:+82-2-2016-5000'>02-2016-5000</a>
              </span>
              <span className='address'>
                서울특별시 강남구 테헤란로87길 36 (삼성동) 도심공항타워 3층
              </span>
            </li>

            <li>
              <span className='name'>구리점</span>
              <span className='tel'>
                TEL: <a href='tel:+82-31-360-0330'>031-360-0330</a>
              </span>
              <span className='address'>
                경기도 구리시 산마루로 5 (갈매동) 대방디엠시티 3층
              </span>
            </li>

            <li>
              <span className='name'>송도점</span>
              <span className='tel'>
                TEL: <a href='tel:+82-1644-7427'>1644-7427</a>
              </span>
              <span className='address'>
                인천광역시 연수구 인천타워대로197번길 16 (송도동) 3층
              </span>
            </li>
          </ul>
        </footer>
      </div>
    </main>
  )
}

export default App
